// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from '@/modules/common/components/Select';
import TextField from '@/modules/common/components/TextField';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';

const initialValues = {
    username: '',
    offer: '',
};

const initialErrors = {
    username: '',
    offer: '',
};

let abortController;

const DialogEdit = (props) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const getOfferOptions = () => {
        return props.offers.map((offer) => ({title: offer.offer_name, value: offer.id.toString()}));
    };

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        if (props.selectedClient) {
            setValues({
                id: props.selectedClient.id,
                username: props.selectedClient.username,
                offer: props.selectedClient.offer.id.toString(),
            });
        }
    }, [props.selectedClient]);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();
        event.preventDefault();
        setFetching(true);
        props.fetch.put(`/api/clients/${props.selectedClient.id}/`, values, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    clear();
                    props.onOk(data);
                }
                else {
                    let _errors = {...initialErrors};
                    _errors.username = (data.username) ? data.username[0] : '';
                    _errors.offer = (data.offer) ? data.offer[0] : '';
                    setErrors(_errors);
                }
                setFetching(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setFetching(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
        props.setSelectedClient(null);
    };

    return (
        <DialogForm title='Изменение клиента' label='Изменить'
                    open={props.open} onClose={handleClose}
                    onSubmit={handleSubmit}
                    disabled={fetching}
        >
            <TextField label="Имя пользователя" type="email"
                       value={values.username} onChange={handleChange('username')}
                       error={errors.username.length > 0}
                       helperText={errors.username}
                       onFocus={handleFocus('username')}
                       autoFocus={true}
            />
            <Select label="Оффер" options={getOfferOptions()}
                    value={values.offer}
                    onChange={handleChange('offer')}
                    error={errors.offer.length > 0}
                    helperText={errors.offer}
                    onFocus={handleFocus('offer')}
            />
        </DialogForm>
    );
};

DialogEdit.propTypes = {
    selectedClient: PropTypes.object,
    setSelectedClient: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogEdit;
Component = withFetch(Component);

export default connect(
    (state) => ({
        offers: state.cfg.offers,
    }),
    null
)(Component);
